import React, { Fragment } from 'react';
import { translate } from 'core/utils';
import { BaasicSelect, BaasicInput } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';

const MarkAsShippedTemplate = ({
	t,
	markAsShippedViewStore: {
		form,
		onKeyUp,
		setInputs,
		warehouseOptions,
		selectedWarehouse,
		onWarehouseSelect,
		loading,
		isInternalShipment,
		onSwitch,
		onCarrierServiceSelect,
		carrierServiceOptions,
		selectedCarrierService,
		handleOnWarehouseMenuScroll,
		handleOnCarrierServiceMenuScroll,
		debouncedWarehouseSearch,
		onMenuCloseWarehouse,
		onMenuCloseCarrier,
		isWarehouseDropdownLoading,
		debouncedCarrierServiceSearch,
		isCarrierServiceLoading,
		isBulkAction,
	},
}) => {
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<ButtonGroup className="k-button-group--fullwidth spc--bottom--sml">
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={isInternalShipment}
						onClick={onSwitch}
						disabled={loading}
					>
						{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.INTERNALSHIPMENT')}
					</Button>
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={!isInternalShipment}
						onClick={onSwitch}
						disabled={loading}
					>
						{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.EXTERNALSHIPMENT')}
					</Button>
				</ButtonGroup>

				{isInternalShipment && (
					<div className="inputgroup">
						{!isBulkAction && (
							<Fragment>
								<BaasicInput field={form.$('trackingNumber')} onKeyUp={onKeyUp} reference={setInputs} />
								<BaasicInput field={form.$('cost')} onKeyUp={onKeyUp} reference={setInputs} />
								<BaasicInput field={form.$('shippingCostSurcharge')} onKeyUp={onKeyUp} reference={setInputs} />
							</Fragment>
						)}
						<div className="spc--bottom--sml">
							<BaasicSelect
								field={form.$('warehouse')}
								options={warehouseOptions.slice()}
								onChange={onWarehouseSelect}
								value={form.$('warehouse').value}
								onMenuScrollToBottom={handleOnWarehouseMenuScroll}
								isLoading={isWarehouseDropdownLoading}
								onMenuClose={onMenuCloseWarehouse}
								onInputChange={debouncedWarehouseSearch}
							/>
						</div>
						<div className="spc--bottom--sml">
							<BaasicSelect
								field={form.$('carrierService')}
								options={carrierServiceOptions.slice()}
								onChange={onCarrierServiceSelect}
								value={selectedCarrierService}
								disabled={loading}
								onMenuScrollToBottom={handleOnCarrierServiceMenuScroll}
								isLoading={isCarrierServiceLoading}
								onMenuClose={onMenuCloseCarrier}
								onInputChange={debouncedCarrierServiceSearch}
							/>
						</div>
					</div>
				)}
				{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={form.submitting}>
					{t('SAVE')}
				</button>
			</div>
		</form>
	);
};

export default defaultTemplate(MarkAsShippedTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarkAsShippedTemplate.jsx